import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IArea } from "src/models/Products/Area.models";

interface AreaState {
  areas: IArea[];
  areaToEdit: IArea | null;
}

const initialState: AreaState = {
  areas: [],
  areaToEdit: null,
};

const areaSlice = createSlice({
  name: "Area",
  initialState,
  reducers: {
    setAreaList: (state, action: PayloadAction<IArea[]>) => {
      state.areas = action.payload;
    },
    concatListArea: (state, action: PayloadAction<IArea[]>) => {
      state.areas = [...state.areas.concat(action.payload)];
    },
    setAreaToEdit: (state, action: PayloadAction<IArea | null>) => {
      state.areaToEdit = action.payload;
    },
    addArea: (state, action: PayloadAction<IArea>) => {
      state.areas.push(action.payload);
    },
    addAreas: (state, action: PayloadAction<IArea[]>) => {
      state.areas.push(...action.payload);
    },
    updateArea: (state, action: PayloadAction<IArea>) => {
      const index = state.areas.findIndex(
        item => item.ordAreaId === action.payload.ordAreaId
      );
      if (index !== -1) state.areas[index] = action.payload;
    },
    deleteArea: (state, action: PayloadAction<string>) => {
      state.areas = state.areas.filter(item => item.ordAreaId !== action.payload);
    },
  },
});

export const {
  setAreaList,
  concatListArea,
  setAreaToEdit,
  addArea,
  addAreas,
  updateArea,
  deleteArea,
} = areaSlice.actions;

export default areaSlice.reducer;
